import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 16.625A1.313 1.313 0 1 0 14 14a1.313 1.313 0 0 0 0 2.625"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.75 8.75H10.936V5.688a3.062 3.062 0 1 1 6.125 0 .875.875 0 0 0 1.75 0 4.813 4.813 0 0 0-9.625 0V8.75H5.249A1.75 1.75 0 0 0 3.5 10.5v12.25a1.75 1.75 0 0 0 1.75 1.75h17.5a1.75 1.75 0 0 0 1.75-1.75V10.5a1.75 1.75 0 0 0-1.75-1.75m-7.876 9.497v1.878a.875.875 0 1 1-1.75 0v-1.878a3.063 3.063 0 1 1 1.75 0"
    }, null, -1)
  ])))
}
export default { render: render }